import { Button, Col, Image, Row } from "react-bootstrap";

import React from "react";

export const Chapter = ({ chapter, index, startBlack = false, newPage = true }) => {
  let ChapterText;
  // eslint-disable-next-line eqeqeq
  if (chapter.buttons === undefined || chapter.buttons === null || chapter.buttons == []) {
    ChapterText =
    <Col md={7} style={{ padding: '10vh' }}>
      <h3>{chapter.title}</h3>
      <p><span dangerouslySetInnerHTML={{ __html: chapter.text }} /></p>
    </Col>;
  } else {
    ChapterText =
    <Col md={7} style={{ padding: '10vh' }}>
      <h3>{chapter.title}</h3>
      <p><span dangerouslySetInnerHTML={{ __html: chapter.text }} /></p>
      {chapter.buttons.map((button, index) => (
        <Button key={'b'+index} variant="link" className="float-right text-sm text-secondary" href={button.link} target={newPage?"_blank":""}>
        {button.bText}
      </Button>
      ))}
    </Col>;
  }
  const ChapterImage =
    <Col md={5} style={{ padding: '5vh' }} className="text-center">
      <Image src={chapter.image} style={{ maxWidth: '100%', maxHeight: '60vh' }} />
    </Col>;


const pairOrNot= startBlack? 1:0;

  if (index % 2 === pairOrNot) {
    return <Row id ={chapter.name}>
      {ChapterText}
      {ChapterImage}
    </Row>
  }
  else {
    return <Row  id ={chapter.name} style={{ backgroundColor: 'black', color: 'white' }}>
      {ChapterImage}
      {ChapterText}
    </Row>
  }

}